import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.querySelectorAll('[data-article-products]').forEach((section) => {
    const slider = section.querySelector('[data-article-products-slider]');
    const previousButton = section.querySelector('[data-article-products-prev]');
    const nextButton = section.querySelector('[data-article-products-next]');

    if (!slider || slider.dataset.articleProductsReady === 'true') {
        return;
    }

    slider.dataset.articleProductsReady = 'true';

    new Swiper(slider, {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: true,
        observer: true,
        observeParents: true,
        roundLengths: true,
        threshold: 5,
        watchOverflow: true,
        navigation:
            previousButton && nextButton
                ? {
                      prevEl: previousButton,
                      nextEl: nextButton,
                  }
                : undefined,
        breakpoints: {
            1024: {
                spaceBetween: 16,
            },
        },
    });
});
